// var cartForm = document.getElementById('cart-form');
// var cartFormBg = document.getElementById('cart-form-bg');
// function toggle() {
// 	if(cartForm.style.display !== 'block') {
// 		cartForm.style.display = 'block';
// 		cartFormBg.style.display = 'block';
// 	}else {
// 		cartForm.style.display = 'none';
// 		cartFormBg.style.display = 'none';
// 	}
// }
// if(cartForm && cartFormBg) {
// 	document.getElementById('cart').addEventListener('click', toggle);
// 	document.getElementById('cart-form-bg').addEventListener('click', toggle);
// 	document.getElementById('cart-close').addEventListener('click', toggle);
// }
//
// var controller = new ScrollMagic.Controller();
// $(function () {
// 	var duration = parseInt($('#right-module-box').height()) - parseInt($('#left-module-box').height());
// 	$('#left-module-box').css('height', window.innerHeight);
// 	var scene = new ScrollMagic.Scene({
// 		triggerElement: '#trigger1',
// 		duration: duration,
// 	}).setPin('#left-module-box')
// 		.offset(0)
// 		.triggerHook(0)
// 		// .addIndicators({name: '1 (duration: '+ duration +')'})
// 		.addTo(controller);
// });

$(function() {
  if (!device.mobile && !device.portrait && !device.ipad) {
    $('#btn-search').on('click', (e) => {
      e.preventDefault()
      $('.search-box').css('display', 'block')
      $('.not-search-box').css('visibility', 'hidden')
      $('.search-input').focus()
    })

    $('#btn-close-search').on('click', () => {
      $('.search-box').css('display', 'none')
      $('.not-search-box').css('visibility', 'visible')
    })
  } else {
    $('#btn-search').on('click', (e) => {
      e.preventDefault()
      $('#btn-search').css('visibility', 'hidden')
      $('.search-box').css({
        display: 'block',
        bottom: '0',
      })
      $('.search-input').focus()
    })
    $('#btn-close-search').on('click', () => {
      $('#btn-search').css('visibility', 'visible')
      $('.search-box').css({
        visibility: 'hidden',
        bottom: 'initial',
      })
    })
  }
})
